<div class="de-toolbar">
  <q9-toolbar>
    <div q9-right-content>
      <span
        *ngFor="let color of palette"
        #stickerDragElement
        class="toolbar-sticker-note"
        [ngStyle]="{background: '#' + color}"></span>
    </div>
  </q9-toolbar>
</div>
